/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceActivityResponse {
    getFixupPrototypeFunction() { return InfraResourceActivityResponse.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceActivityResponse>): InfraResourceActivityResponse {
        let obj = Object.assign(new InfraResourceActivityResponse(), model);
        InfraResourceActivityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceActivityResponse>): InfraResourceActivityResponse {
        if (!model) return null;
        return InfraResourceActivityResponse.newInstance(<InfraResourceActivityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceActivityResponse) {
        if (!obj) return;

        models.InfraResourceActivityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceActivityResponse): boolean {
        Object.setPrototypeOf(obj, InfraResourceActivityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.events) {
            for (let val of this.events) {
                models.InfraResourceActivityEvent.fixupPrototype(val);
            }
        }
    }

    /**
     * List of activity events.
     */
    events: Array<models.InfraResourceActivityEvent>;

    /**
     * Pagination context for next page. Present only in Mode 1.
     */
    next_list_context: models.ListContext;

}
